export const createTokenSlice = (set) => ({
    token: '',
    tokenData: null,
    setToken: (token) => set(() => ({ token: token })),
    setTokenData: (data) => set(() => ({ tokenData: data })),
    clearToken: () => set(() => ({ token: '' })),
  })